import React from 'react';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { Location } from '../../../app/models/Location';
import LocationForm from './forms/LocationForm';

interface Props {
    fetching?: boolean;
    action: () => void;
    cancel: () => void;
    location: Location;
    setLocation: (location: Location) => void;
    errorFields?: any;
}

const LocationFormContainer = ({
    fetching,
    action,
    cancel,
    location,
    setLocation,
    errorFields = null
}: Props) => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <LocationForm
                        locationDataForm={location}
                        setLocationDataForm={setLocation}
                        errorFields={errorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetching} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={action} locked={fetching} />
                </div>
            </div>
        </>
    );
};

export default LocationFormContainer;
